import type { RouteRecordRaw } from 'vue-router'

export const testRoutes: RouteRecordRaw[] = [
    {
        name: '__test_root',
        path: 'test',
        component: () => import('@/views/JustRouter.vue'),
        children: [
            {
                name: 'test_base',
                path: '',
                component: () => import('@/views/test/Base.vue'),
            },
            {
                name: '__test_page_root',
                path: 'page',
                component: () => import('@/views/JustRouter.vue'),
                children: [
                    // {
                    //     name: 'test_page_meta',
                    //     path: 'meta',
                    //     component: () =>
                    //         import(
                    //             '@/views/test/page/PageMeta.vue'
                    //         ),
                    // },
                    {
                        name: 'test_page_404',
                        path: '404',
                        component: () => import('@/views/test/page/404.vue'),
                    },
                    {
                        name: 'test_page_500',
                        path: '500',
                        component: () => import('@/views/test/page/500.vue'),
                    },
                    {
                        name: 'test_page_currency',
                        path: 'currency',
                        component: () =>
                            import('@/views/test/page/Currency.vue'),
                    },
                    // {
                    //     name: 'test_page_test',
                    //     path: 'test',
                    //     component: () =>
                    //         import(
                    //             '@/views/test/page/Test.vue'
                    //         ),
                    // },
                    {
                        name: 'test_page_faceted_content',
                        path: 'faceted-content',
                        component: () =>
                            import('@/views/test/page/FacetedContent.vue'),
                    },
                    {
                        name: 'test_page_slow_init',
                        path: 'slow-init',
                        component: () =>
                            import('@/views/test/page/InitAndDataSpeed.vue'),
                    },
                    {
                        name: 'test_page_internal_linking',
                        path: 'internal-linking',
                        component: () =>
                            import('@/views/test/page/InternalLinking.vue'),
                    },
                    {
                        name: 'test_page_initial_url',
                        path: 'initial-url',
                        component: () =>
                            import('@/views/test/page/InitialUrl.vue'),
                    },
                    {
                        name: 'test_page_initial_url_alternate',
                        path: 'initial-url-alternate',
                        component: () =>
                            import('@/views/test/page/InitialUrl.vue'),
                    },
                    {
                        name: 'test_page_nice_guy_zoomer',
                        path: 'nice-guy-zoomer',
                        component: () =>
                            import('@/views/test/page/NiceGuyZoomer.vue'),
                    },
                    {
                        name: '__test_page_cookie_root',
                        path: 'cookie',
                        component: () => import('@/views/JustRouter.vue'),
                        children: [
                            {
                                name: 'test_page_cookie_boolean',
                                path: 'boolean',
                                component: () =>
                                    import('@/views/test/page/cookie/Boolean.vue'),
                            },
                            {
                                name: 'test_page_cookie_currency',
                                path: 'currency',
                                component: () =>
                                    import('@/views/test/page/cookie/Currency.vue'),
                            },
                            {
                                name: 'test_page_cookie_country',
                                path: 'country',
                                component: () =>
                                    import('@/views/test/page/cookie/Country.vue'),
                            },
                        ],
                    },
                ],
            },

            {
                name: '__test_component_root',
                path: 'component',
                component: () => import('@/views/JustRouter.vue'),
                children: [
                    {
                        name: '__test_component_cms_root',
                        path: 'cms',
                        component: () => import('@/views/JustRouter.vue'),
                        children: [
                            {
                                name: 'test_component_cms_side_by_side_images',
                                path: 'side-by-side-images',
                                component: () =>
                                    import('@/views/test/component/cms/SideBySideImages.vue'),
                            },
                        ],
                    },
                    {
                        name: '__test_component_gallery_root',
                        path: 'gallery',
                        component: () => import('@/views/JustRouter.vue'),
                        children: [
                            {
                                name: 'test_component_gallery_gallery_modal',
                                path: 'gallery-modal',
                                component: () =>
                                    import('@/views/test/component/gallery/TestGalleryModal.vue'),
                            },
                        ],
                    },

                    {
                        name: '__test_component_gallery_root',
                        path: 'gallery',
                        component: () => import('@/views/JustRouter.vue'),
                        children: [
                            {
                                name: 'test_component_gallery_gallery_modal',
                                path: 'gallery-modal',
                                component: () =>
                                    import('@/views/test/component/gallery/TestGalleryModal.vue'),
                            },
                        ],
                    },
                    {
                        name: 'test_component_index',
                        path: '',
                        component: () =>
                            import('@/views/test/component/Index.vue'),
                    },
                    {
                        name: 'test_component_th_title',
                        path: 'th-title',
                        component: () =>
                            import('@/views/test/component/TestThTitle.vue'),
                    },
                    {
                        name: 'test_component_slider',
                        path: 'slider',
                        component: () =>
                            import('@/views/test/component/Slider.vue'),
                    },
                    {
                        name: 'test_component_slider_with_inputs',
                        path: 'slider-with-inputs',
                        component: () =>
                            import('@/views/test/component/SliderWithTextInputs.vue'),
                    },
                    {
                        name: 'test_component_slider_exponential',
                        path: 'exponential-slider',
                        component: () =>
                            import('@/views/test/component/ExponentialSlider.vue'),
                    },
                    {
                        name: 'test_component_slider_exponential_with_inputs',
                        path: 'exponential-slider-with-inputs',
                        component: () =>
                            import('@/views/test/component/ExponentialSliderWithInputs.vue'),
                    },
                    {
                        name: 'test_component_th_select',
                        path: 'th-select',
                        component: () =>
                            import('@/views/test/component/TestThSelect.vue'),
                    },
                ],
            },
            {
                name: '__test_nav_root',
                path: 'nav',
                component: () => import('@/views/JustRouter.vue'),
                children: [
                    {
                        name: 'test_nav',
                        path: '',
                        component: () =>
                            import('@/views/test/nav/NavigationDummies.vue'),
                    },
                    {
                        name: 'test_nav_one',
                        path: 'one',
                        component: () =>
                            import('@/views/test/nav/NavigationDummyOne.vue'),
                    },
                    {
                        name: 'test_nav_two',
                        path: 'two',
                        component: () =>
                            import('@/views/test/nav/NavigationDummyTwo.vue'),
                    },
                ],
            },
        ],
    },
    {
        name: 'doc',
        path: 'doc',
        component: () => import('@/views/JustRouter.vue'),
        children: [
            {
                name: 'doc.icons',
                path: 'icons',
                component: () => import('@/views/zdoc/Icons.vue'),
            },
        ],
    },
] satisfies RouteRecordRaw[]
